module.exports = __webpack_public_path__ + "static/img/Morris.87d8266.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Morris.jpg
// module id = pKpW
// module chunks = 0